import React from "react";

export default function Left() {
  return <i className="fas fa-chevron-left" />;
}
